import { Field } from "formik";
import PostalAddressFormLocal from "./PostalAddressFormLocal";
import PostalCodeForm from "./PostalCodeForm";
import PostalAddressFormForeign from "./PostalAddressFormForeign";
import ElectronicAddress from "./ElectronicAddress";
import { useEffect } from "react";

const ResidentialDetails = ({
  values,
  isNonResident,
  disable,
  setFieldValue,
  company,
  organization,
  formType,
  formStepErrors,
}) => {
  useEffect(() => {
    if (company && formType === "company") {
      setFieldValue(
        "postalAddress.postalAddress",
        company?.registeredOffice.postalAddress || "N/A"
      );
      setFieldValue(
        "postalAddress.postalCode",
        company.registeredOffice.postalCode || "N/A"
      );
      setFieldValue(
        "postalAddress.serviceAddress",
        company?.registeredOffice?.serviceAddress || "N/A"
      );
    } else if (organization && formType === "organization") {
      setFieldValue(
        "postalAddress.postalAddress",
        organization.postalAddress.postalAddress || "N/A"
      );
      setFieldValue(
        "postalAddress.postalCode",
        organization.postalAddress.postalCode || "N/A"
      );
      setFieldValue(
        "postalAddress.serviceAddress",
        organization.postalAddress.serviceAddress || "N/A"
      );
    }
  }, [company, setFieldValue, organization]);

  return (
    <>
      <div>
        {((values.idType === "Kenyan Citizen" && isNonResident === "No") ||
          values.idType === "Foreign Resident") && (
          <>
            <div className="px-4 mt-4 space-y-4 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6">
              <Field
                name="postalAddress"
                component={PostalAddressFormLocal}
                idType={values.idType}
                disabled={true}
              />
              <Field
                name="postalAddress"
                component={PostalCodeForm}
                disabled={true}
              />
            </div>
            <Field
              name="electronicAddress"
              component={ElectronicAddress}
              values={values}
              disabled={disable}
              setFieldValue={setFieldValue}
              disableEmailAddress={false}
              formStepErrors={formStepErrors}
            />
          </>
        )}
        {(values.idType === "Foreigner" ||
          (values.idType === "Kenyan Citizen" && isNonResident === "Yes")) && (
          <>
            <div className="px-4 mt-4 space-y-4 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6">
              <Field
                name="postalAddress"
                component={PostalAddressFormForeign}
                idType={values.idType}
                disabled={true}
              />
            </div>
            <Field
              name="electronicAddress"
              component={ElectronicAddress}
              values={values}
              disabled={disable}
              setFieldValue={setFieldValue}
              disableEmailAddress={disable}
              formStepErrors={formStepErrors}
            />
          </>
        )}
      </div>
    </>
  );
};
export default ResidentialDetails;
